<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../types';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpUserFinancePanel from 'src/features/user/kp-user-finance-panel/KpUserFinancePanel.svelte';

    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();
    const user = pageContext.staticData.user;
    const detailView = pageContext.staticData.detailView;
</script>

<div class="kp-user-account-finance-panel-part">
    <KpUserFinancePanel {user}
                        enabledPaymentProviderNames="{detailView.enabledPaymentProviderNames}"
                        userCanDeletePayment="{detailView.canPaymentDelete}"
                        userCanDeleteDebt="{detailView.canDebtDelete}"/>
</div>